import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ExpandMoreIcon from 'on_web/components/shared/CustomIcons/ExpandMoreIcon';
import { Box } from '@material-ui/core';
import { APP_PRIMARY } from 'colours';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    lineHeight: '1.19',
  },
  heading: {
    fontFamily: 'Museo-500',
    fontSize: '16px',
    color: APP_PRIMARY,
  },
  item: {
    color: '#222222',
    paddingBottom: '20px',
  },
}));

/**
 * Component displaying one redirecting panel that looks exactly as the ExpansionPanelWithIcon component.
 *
 * @param {Component properties} props
 */
export default function RedirectPanelWithIcon(props) {
  const classes = useStyles();

  const handleChange = () => event => {
    props.onClick(props.categoryCode);
  };

  return (
    <Box
      className={classes.root}
      style={{
        borderTop: '1px Solid #efefef',
      }}
      onClick={handleChange()}
    >
      <Grid container direction="row" justify="flex-start" alignItems="center">
        {props.icon && (
          <Grid item xs={2} sm={1}>
            {props.icon}
          </Grid>
        )}
        <Grid item xs={9} sm={10}>
          <Typography className={classes.heading}>{props.title}</Typography>
        </Grid>
        <Grid item xs={1} sm={1}>
          <Box
            display="flex"
            justifyContent="flex-end"
            style={{
              marginRight: '10px',
            }}
          >
            <ExpandMoreIcon expanded={false} color={APP_PRIMARY} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

RedirectPanelWithIcon.propTypes = {
  /**
   * Icon displayed left from title.
   */
  icon: PropTypes.string.isRequired,

  /**
   * Title displayed right from icon.
   */
  title: PropTypes.string.isRequired,

  /**
   * Items to be displayed inside panel.
   */
  items: PropTypes.arrayOf(PropTypes.string),

  /**
   * Color of the title.
   */
  titleColor: PropTypes.string.isRequired,

  /**
   * Code of the current category.
   */
  categoryCode: PropTypes.string.isRequired,

  /**
   * Function that is called when panel is clicked.
   */
  onClick: PropTypes.func,
};
